import axios, { type InternalAxiosRequestConfig } from 'axios';
import { startGlobalLoading, stopGlobalLoading } from '@/utils/loadingBridge';

const MUTATING_METHODS = new Set(['post', 'put', 'patch', 'delete']);

function shouldTrackLoader(config: InternalAxiosRequestConfig): boolean {
  if (config.skipGlobalLoader) {
    return false;
  }

  const method = config.method?.toLowerCase();
  return method ? MUTATING_METHODS.has(method) : false;
}

const api = axios.create({
    baseURL: import.meta.env.VITE_API_BASE_URL || 'http://localhost:8000/api',
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
});

// Intercepteur de REQUÊTE : token + loader global (mutations)
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    if (shouldTrackLoader(config)) {
      startGlobalLoading();
      config._globalLoaderActive = true;
    }

    return config;
  },
  (error) => {
    if (error.config?._globalLoaderActive) {
      stopGlobalLoading();
    }
    return Promise.reject(error);
  },
);

// Intercepteur de RÉPONSE : fin du loader + gestion 401
api.interceptors.response.use(
  (response) => {
    if (response.config._globalLoaderActive) {
      stopGlobalLoading();
    }
    return response;
  },
  (error) => {
    if (error.config?._globalLoaderActive) {
      stopGlobalLoading();
    }

    const token = localStorage.getItem('auth_token');

    if (error.response?.status === 401 && token) {
      localStorage.removeItem('auth_token');
      if (!['/login', '/register'].includes(window.location.pathname)) {
        window.location.href = '/login?expired=true';
      }
    }

    return Promise.reject(error);
  },
);

export default api;
